import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfBidding } from 'src/database';
import api from 'src/services/api';

export const useListBiddingsController = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState(false);
	const [biddingsData, setBiddingsData] = useState<ModelOfBidding[]>([]);

	const getBiddings = () => {
		setLoading(true);

		api.get(`biddings/${userAgencyId}`)
			.then(response => {
				const data = response.data;

				setBiddingsData(data);
				setLoading(false);
			})
			.catch(err => {
				console.log(err);
				setLoading(false);
			});
	};

	useEffect(() => {
		getBiddings();
	}, []);

	return {
		getListBiddings: {
			loading,
			biddingsData,
		},
	};
};
